import { StockApi } from '../../../api/Stock'
import Stock from '../../../components/Main/Stock/Stock'
import React from 'react'

import useFetchList from '../../../elements/Hooks/useFetchList'
import useModalData from '../../../elements/Hooks/useModalData'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'

function StockCont() {
  const { list: cached, fetching, fetch } = useFetchList(() => StockApi.list())
  const { list, company, onChangeCompany } = useListCompanyFilter(cached, fetching)
  const {
    visible,
    modalType,
    object: stock,
    submitting,
    submit,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    update,
  } = useModalData(StockApi.create, StockApi.update, StockApi.remove, fetch)

  const isNew = modalType === 'new'

  return (
    <Stock
      {...{
        list,
        fetching,
        submitting,
        visible,
        fetch,
        stock,
        onShow,
        onCancel,
        submit,
        removing,
        remove,
        update,
        modalType,
        formRef,
        company,
        onChangeCompany,
        isNew,
      }}
    />
  )
}

export default (StockCont)
